import { SampleCard, SampleCardProps } from "components/shared/SampleCard";
import { Pagination } from "components/shared/Pagination";
import s from "./EssayFiltersView.module.scss";
import { Heading } from "components/UI/typography/Heading";
import { CTACardPreviewResults } from "@/components/shared/CTACardPreviewResults";
import { Fragment } from "react";
import { SelectedValues } from "@/utils/usePageFIlters";

export type EssayFiltersViewProps = {
  items: SampleCardProps[];
  currentPage: number;
  pagesCount: number;
  baseUrl: string;
};

const showCTACard = (index: number, total: number) => {
  if (total < 3 && index + 1 === total) return true;
  if (index === 2) return true;
  if (total > 7) {
    return index === total - 3;
  }
  return false;
};

export const EssayFiltersView = ({ items, currentPage, pagesCount, baseUrl }: EssayFiltersViewProps) => {
  return (
    <>
      <main className={s.samplesList}>
        {items.length ? (
          items.map((item, index) => (
            <Fragment key={index}>
              <SampleCard headingTag={2} {...item} className={s.card} />
              {showCTACard(index, items.length) && <CTACardPreviewResults />}
            </Fragment>
          ))
        ) : (
          <Heading key="n/a" level={4} className={s.nothingFound}>
            Nothing found
          </Heading>
        )}
      </main>

      {pagesCount > 1 && (
        <Pagination
          baseUrl={baseUrl}
          currentPage={currentPage > pagesCount ? null : currentPage}
          pagesCount={pagesCount}
        />
      )}
    </>
  );
};
